<script setup lang="ts">
defineProps<{ active?: boolean }>()
</script>

<!--
  Onglet « Équipes ». Trait au repos, plein une fois actif — cf. l'en-tête de
  `IconHome` pour la règle.

  L'état plein n'est pas l'état en trait rempli : les épaules y sont deux
  demi-disques qui se RECOUVRENT (celui de derrière déborde de celui de
  devant), et non une forme tronquée par l'autre. De la même couleur, ils
  fusionnent en une seule silhouette — c'est ce qui fait tenir un
  `person.2.fill` à 25 px, là où des épaules tronquées laisseraient une
  encoche au milieu du plein.
-->
<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <template v-if="active">
      <!-- celle de derrière, posée d'abord : le reste la recouvre -->
      <circle cx="17.4" cy="8.8" r="2.5" fill="currentColor" stroke-width="1" />
      <path d="M13.6 20a4.3 4.3 0 0 1 8.6 0z" fill="currentColor" stroke-width="1" />

      <!-- celle de devant -->
      <circle cx="9.6" cy="9" r="3.6" fill="currentColor" stroke-width="1" />
      <path d="M3.4 20a6.2 6.2 0 0 1 12.4 0z" fill="currentColor" stroke-width="1" />
    </template>

    <template v-else>
      <!-- la personne de devant -->
      <circle cx="9.6" cy="9" r="3.6" stroke-width="1.8" />
      <path d="M3.4 20a6.2 6.2 0 0 1 12.4 0" stroke-width="1.8" />

      <!-- celle de derrière : plus petite, décalée, épaules tronquées -->
      <circle cx="17.4" cy="8.8" r="2.5" stroke-width="1.8" />
      <path d="M14.7 16.1a4.8 4.8 0 0 1 7.5 3.9" stroke-width="1.8" />
    </template>
  </svg>
</template>
